$(function(){
    $('.product-img .product-types li').hover(function(){
        $(this).addClass('active');
        $(this).parent().find('li').not($(this)).removeClass('active');
        // $('.product-img .product-types li').not($(this)).removeClass('active');

        var itemData = $(this).attr('data-product');
        // $(this).parent().siblings().find('img[data-productImg="' + itemData + '"]').show();
        if($(this).parents('.character-item').length){
            $(this).parent().siblings().find('img[data-productImg="' + itemData + '"]').css('display', 'block');
        }else{
            $(this).parent().siblings().find('img[data-productImg="' + itemData + '"]').show();
        }
        $(this).parent().siblings().find('img').not('img[data-productImg="' + itemData + '"]').hide();
        // $('.product-img .productImg-wrapper').find('img[data-productImg="' + itemData + '"]').show();
        // $('.product-img .productImg-wrapper img').not('img[data-productImg="' + itemData + '"]').hide();
    });
    
    $('.product-slider').slick('unslick').slick({
        infinite: false,
        arrows: true,
        dots: true
    });

    $('.product-characters .slider-component').slick('unslick').slick({
        infinite: false,
        arrows: true,
        dots: true
    });

    $(".product-characters .slider-component .slick-arrow").click(function(){
        $(this).attr("data-kl-event", "eventClick")
        $(this).attr("data-kl-category", "kleenex_kids")
        $(this).attr("data-kl-action", "click-slider")
        if($(this).hasClass('slick-prev')){
          $(this).attr("data-kl-label", "left")
        }else{
          $(this).attr("data-kl-label", "right")
        }
    });

    $('.patterns-list ul li:first-child').addClass('pattern-active');


    $('.patterns-list ul li').click(function(){
        $(this).addClass('pattern-active');
        $('.patterns-list ul li').not(this).removeClass('pattern-active')
        var patternImg = $(this).attr('data-img');
        var firstItemImg = $('.product-slider .product-slider-item:first-child img');
        var firstItemCircle = $('.product-img .product-types li:first-child');
        var firstItemImgD = $('.product-img .productImg-wrapper img:first-child');
        firstItemCircle.addClass('active');
        $('.product-img .product-types li').not(firstItemCircle).removeClass('active');
        $('.product-slider').slick('slickGoTo', 0);
        firstItemImgD.attr('src', patternImg);
        firstItemImg.attr('src', patternImg);
        firstItemImgD.show();
        $('.product-img .productImg-wrapper img').not(firstItemImgD).hide();
    })

    // $('.sizes-list li').click(function(){
    //     $(this).addClass('active');
    //     $('.sizes-list li').not($(this)).removeClass('active');

    //     // var sizeData = $(this).attr('data-size');
    //     // $('.available-counts').find('ul[data-counts="' +sizeData + '"]').addClass('active');
    //     // $('.available-counts ul').not('ul[data-counts="' + sizeData + '"]').removeClass('active');

    //     var firstStore = $('.available-counts ul.active li:first-of-type').attr('data-wherebuy');
    //     console.log(firstStore)
    //     $('.available-counts ul.active li:first-of-type').addClass('active');
    //     $('.available-counts ul li[data-wherebuy]').not('.available-counts ul.active li:first-of-type').removeClass('active');
    //     $('.where-buy').find('div[data-stores="' +firstStore + '"]').addClass('storeactive');
    //     $('.where-buy .store-list').not('div[data-stores="' + firstStore + '"]').removeClass('storeactive');
    //     // $('.where-buy').find('div[data-stores="' +sizeData + '"]').addClass('storeactive');
    //     // $('.where-buy .store-list').not('div[data-stores="' + sizeData + '"]').removeClass('storeactive');
    // });

    $('.available-counts ul li[data-wherebuy]').click(function(){
        var storesData = $(this).attr('data-wherebuy');
        console.log(storesData)
        
        $(this).addClass('active');
        $('.available-counts ul li[data-wherebuy]').not($(this)).removeClass('active');

        $('.where-buy').find('div[data-stores="' +storesData + '"]').addClass('storeactive');
        $('.where-buy .store-list').not('div[data-stores="' + storesData + '"]').removeClass('storeactive');

        $('.product-view img').removeClass('product-active');
        $('.product-view').find('img[data-size="' +storesData + '"]').addClass('product-active');

        if(window.innerWidth < 768){
            var scrollStores = $('.product-sizes .where-buy').offset().top - 300;
            $("html, body").animate({ scrollTop: scrollStores}, "slow");
             return false;
        }
    });

    $('.sizes-dropdown .size-active').click(function(e){
        e.preventDefault();
        $(this).next().slideToggle('fast');
    })
})


// TAGGING VIDEO

var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

var player;
var myTimer;
function onYouTubeIframeAPIReady() {
    player = new YT.Player( 'tagvideo', {
    events: { 'onStateChange': onPlayerStateChange}
    });
}
// function onPlayerReady(event) {
//     event.target.playVideo();
//   }
function onPlayerStateChange(event) {
    switch(event.data) {
    case 0:
        dataLayer.push({
            'eventCategory': 'video',
            'eventAction': 'video_consumption_100%',
            'eventLabel': player.playerInfo.videoData.title,
            'eventvalue': '',
            'event': 'videoEvents'
        });
        clearInterval(myTimer);
        break;
    case 1:
        var dur =  parseInt( player.getDuration());
        var p25= parseInt(25 * dur / 100);
        var p50= parseInt(50 * dur / 100);
        var p75= parseInt(75 * dur / 100);
        dataLayer.push({
            'eventCategory': 'video',
            'eventAction': 'start_video_playback',
            'eventLabel': player.playerInfo.videoData.title,
            'eventvalue': '',
            'event': 'videoEvents'
        });

        myTimer = setInterval(function(){ 
            if(parseInt(player.getCurrentTime()) == p25){
                dataLayer.push({
                    'eventCategory': 'video',
                    'eventAction': 'video_consumption_25%',
                    'eventLabel': player.playerInfo.videoData.title,
                    'eventvalue': '',
                    'event': 'videoEvents'
                });
            }else if(parseInt(player.getCurrentTime()) == p50){
                dataLayer.push({
                    'eventCategory': 'video',
                    'eventAction': 'video_consumption_50%',
                    'eventLabel': player.playerInfo.videoData.title,
                    'eventvalue': '',
                    'event': 'videoEvents'
                });
            }else if(parseInt(player.getCurrentTime()) == p75){
                dataLayer.push({
                    'eventCategory': 'video',
                    'eventAction': 'video_consumption_75%',
                    'eventLabel': player.playerInfo.videoData.title,
                    'eventvalue': '',
                    'event': 'videoEvents'
                });
            }
        }, 1000);
        break;
    case 2:
        clearInterval(myTimer);
        break;
    }
}